import React from "react";
import DataGrid, {
  Column,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  SearchPanel,
} from "devextreme-react/data-grid";

const SuperTableProductivity = (props) => {

  return (
    <DataGrid
      dataSource={props.data}
      showBorders={true}
      showRowLines={true}
      columnHidingEnabled={props.hideCols}
      noDataText="Sin datos."
      height={props.height || null}
      className={props.withDd ? 'table-ddl' : ''}
    >
      {!props.noSearch && (
        <SearchPanel visible={true} width={250} placeholder={props.textSearch} />
      )}
      { (!props.showProjectsProductivity) && <>
             {/* <GroupPanel visible={true} />
             <Grouping autoExpandAll={false} /> */}
             <Column dataField="Proyecto" caption="ProyectoNuevo" groupIndex={0} />
             </>
      }
      <GroupPanel visible={true} />
      <Grouping autoExpandAll={false} />
      <Column dataField="Proyecto" caption={props.title_proje} groupIndex={0} />
      
      {props.columns.map((itmCol, index) => {
        return ( 
          <Column
            key={index}
            dataField={itmCol.selector}
            caption={itmCol.caption}
            width={itmCol.width}
            alignment={itmCol.align}
            cellRender={(row) => {
              return (
                <>{itmCol.customRender ? itmCol.customRender(row) : row.text}</>
              );
            }}
          />
         
          );
      })}
    </DataGrid>
  );
};

export default  SuperTableProductivity;
